const ILLUSTRATION_SIZE = 200;

export default ({ breakpoints, palette, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    width: '100%',
    paddingBottom: spacing(1),
    borderBottom: `1px solid ${palette.divider}`,
    [breakpoints.up('sm')]: {
      width: `calc(100% - (${spacing(4)} + ${ILLUSTRATION_SIZE}px))`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      columnGap: spacing(2),
      paddingTop: spacing(3),
    },
  },
  list: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    margin: spacing(1, 0, 2),
    padding: 0,
    [breakpoints.up('sm')]: {
      width: '65%',
      margin: 0,
    },
  },
  listItemContainer: {
    alignItems: 'flex-start',
    paddingLeft: 0,
  },
  listItem: {
    marginTop: spacing(2),
    width: '100%',
  },
  iconContainer: {
    border: '1px solid',
    borderColor: 'var(--color)',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    marginRight: spacing(2),
    width: 32,
    minWidth: 32,
    height: 32,
  },
  picture: {
    width: ILLUSTRATION_SIZE,
    minWidth: ILLUSTRATION_SIZE,
    height: ILLUSTRATION_SIZE,
  },
});
